import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchInfosDemandeEnlevement } from 'store/reclamation/detailsActions';
import { clearArticleGestionValue } from 'store/articleGestion/articlesGestionActions';

import RenvoiEnPayantDialogContent from './RenvoiEnPayantDialogContent';
import withLoader from 'components/Shared/withLoader';

const RenvoiEnPayantDialogContentWithLoader = withLoader(RenvoiEnPayantDialogContent);

class RenvoiEnPayantDialogContentContainer extends React.Component {


    async componentDidMount() {
        await this.props.fetchInfosDemandeEnlevement(this.props.reclamationId);
        await this.props.clearArticleGestionValue();
    }

    
    render() {
        const { isLoading, onChange, action, articles, adresse, contact, transporteurInitial, reclamationId } = this.props;

        return (
            <RenvoiEnPayantDialogContentWithLoader
                isLoading={isLoading}
                onChange={onChange}
                action={action}
                articles={articles}
                adresse={adresse}
                contact={contact}
                transporteurInitial={transporteurInitial}
                clearArticleGestionValue={clearArticleGestionValue}
                reclamationId={reclamationId}
            />
        );
    }
}

RenvoiEnPayantDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    reclamationId: PropTypes.number.isRequired
};

const mapStateToProps = (state) => ({
    articles: state.reclamation.details.infosDemandeEnlevement.articles,
    adresse: state.reclamation.details.infosDemandeEnlevement.adresse,
    contact: state.reclamation.details.infosDemandeEnlevement.contact,
    transporteurInitial: state.reclamation.details.infosDemandeEnlevement.transporteurInitial,
    isLoading: state.reclamation.details.infosDemandeEnlevement.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchInfosDemandeEnlevement: (reclamationId) => dispatch(fetchInfosDemandeEnlevement(reclamationId)),
    clearArticleGestionValue: () => dispatch(clearArticleGestionValue('addAction'))
});

export default connect(mapStateToProps, mapDispatchToProps)(RenvoiEnPayantDialogContentContainer);
